import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
 // @Input() reason!: string;
  @Output() saveDocumentwithReason = new EventEmitter<any>();
  @Output() isModelOpen = new EventEmitter<boolean>();
  @Input() reasonValidationMessage : string = "";
  @Input() heading : string = "";
  @Input() confirmationMessage : string = "";

  reason = '';
  isModalVisable = true;
  isReasonForDocumentUpdateRequired = false;

  constructor() {
   }

  ngOnInit(): void {
  }

  saveDocument(){
    if(this.reason.length > 0){
      this.saveDocumentwithReason.emit(this.reason)
    }
    else{
      this.isReasonForDocumentUpdateRequired = true;
    }
  }
  
  closeReasonDailog(){   
    this.isModelOpen.emit(false) 
  }
  
  onDialogHide(){
    this.isModelOpen.emit(false) 
  }
}
